import { pages as registryPages } from "@prism/shared/modules";

/**
 * Page-key helpers shared by App.jsx (Shell chrome) and the ClientSwitcher.
 *
 * "Dashboard" pages are the client-data pages from the shared module registry
 * (group "main": overview, traffic, ads, …) — they show the date picker and
 * re-render when the viewed client changes. Everything else (agency home,
 * admin pages, profile/account, my-clients, our-services) is frontend-only
 * chrome derived from the route, not the registry.
 */
export const DASHBOARD_PAGE_KEYS = new Set(
  registryPages.filter((p) => p.group === "main").map((p) => p.key)
);

/**
 * Derive the activePage key from a pathname. "/traffic" → "traffic".
 * Admin sub-pages share the "/admin" first segment, so disambiguate on the
 * second segment: "/admin/organization" → "admin-organization", everything else
 * under /admin (clients list, new, detail) → "admin". Same idea for /agency.
 */
export function pageKeyFromPath(pathname) {
  const segments = pathname.replace(/^\//, "").split("/");
  let key = segments[0] || "overview";
  if (key === "admin") {
    key = segments[1] === "organization" ? "admin-organization"
      : segments[1] === "team" ? "admin-team"
      : segments[1] === "catalog" ? "admin-catalog"
      : "admin";
  }
  if (key === "agency") {
    key = segments[1] === "pipeline" ? "agency-pipeline"
      : segments[1] === "proposals" ? "agency-proposals"
      : segments[1] === "contracts" ? "agency-contracts"
      : segments[1] === "billing" ? "agency-billing"
      : segments[1] === "work" ? "agency-work"
      : segments[1] === "orders" ? "agency-orders"
      : "agency";
  }
  return key;
}

/** True when the pathname points at a client-data dashboard page. */
export function isDashboardPath(pathname) {
  return DASHBOARD_PAGE_KEYS.has(pageKeyFromPath(pathname));
}
